import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import PvTable from "../../components/Table/PvTable";
import useAxios from "../../hooks/useAxios";
import PvForm from "../../components/Form/PvForm";
import Popup from "../../components/Popup";

import { Alert, Button, Space, Typography, Tooltip } from "antd";

import TableSkeleton from "../../components/Loading/TableSkeleton";

import { PlusCircleOutlined } from "@ant-design/icons";
import PvCardList from "../DataView/PvCardList";
import DataView from "../DataView/DataView";
import { toUiPosition } from "../../utils/generalUtils";

const BaseDocumentRequest = ({
  docType,
  title,
  description,
  columns,
  formFields,
  viewingDataConfig,
  apiConfig,
  dataMapper,
  popupWidth,
  submitTransform,
  viewingType,
  viewingModalWidth,
}) => {
  const { id, positions } = useSelector(
    (state) => state.accountDetailSlice.details,
  );

  const { dataView } = useSelector((state) => state.generalSlice);

  const { response, loading, fetchData } = useAxios();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRefresh = () => {
    fetchData({ url: `${apiConfig.get}/${id}`, method: "GET" });
  };

  useEffect(() => {
    handleRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updatedColumn =
    typeof columns === "function" ? columns(handleRefresh) : columns;

  const mappedData = (response?.data || []).map((item, index) =>
    dataMapper(item, index),
  );

  const normalizedPositions = (positions || []).map((position) =>
    toUiPosition(position),
  );
  const activePositions = normalizedPositions.filter(
    (position) => !position.is_inactive,
  );
  const hasActivePosition = activePositions.length > 0;
  const defaultActivePositionId = activePositions?.[0]?.position_id;

  const positionField = [
    {
      name: "position_id",
      label: "Position",
      dropdownItems: normalizedPositions,
      inputName: "submitter_position",
      type: "position-dropdown",
      ...(activePositions?.length === 1 && { disabled: true }),
      ...(!hasActivePosition && { disabled: true }),
    },
  ];

  const allFormFields = [...positionField, ...formFields];

  const handleModalCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {loading ? (
        <TableSkeleton tableType="request" />
      ) : (
        <>
          <Space
            style={{
              paddingBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography.Title
              level={3}
              style={{
                margin: 0,
                color: "#862633",
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
              }}
            >
              {title}
            </Typography.Title>
            <Button
              size="large"
              style={{ background: "#862633" }}
              icon={<PlusCircleOutlined />}
              type="primary"
              disabled={!hasActivePosition}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              Add
            </Button>
          </Space>
          {!hasActivePosition && (
            <Alert
              style={{ marginBottom: "10px" }}
              message="No active position available."
              description="All your position assignments are inactive. You can view them, but you cannot submit a new request."
              type="warning"
              showIcon
            />
          )}
          <Alert
            style={{ marginBottom: "10px" }}
            message={
              <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                {title} Form
              </span>
            }
            description={
              <span
                style={{
                  whiteSpace: "pre-line",
                  fontStyle: "italic",
                  color: "#333",
                }}
              >
                {description}
              </span>
            }
            type="info"
            showIcon
          />
          {/* <PvTable
            data={mappedData}
            columns={updatedColumn}
            loading={loading}
            onRowClick={() => {}}
            maxActiveRow={5}
          /> */}

          <DataView style={{ marginBottom: "12px" }} />

          {dataView === "table" ? (
            <PvTable
              data={mappedData}
              columns={updatedColumn}
              loading={loading}
              onRowClick={() => {}}
              maxActiveRow={5}
            />
          ) : (
            <PvCardList
              data={mappedData}
              columns={updatedColumn}
              onRowClick={() => {}}
              loading={loading}
              maxActiveRow={5}
            />
          )}

          <Popup
            title={title}
            isOpen={isModalOpen}
            footer={null}
            onCancel={handleModalCancel}
            width={popupWidth}
          >
            <PvForm
              formFields={allFormFields}
              initialValues={{ position_id: defaultActivePositionId }}
              viewingDataConfig={viewingDataConfig}
              viewingType={viewingType}
              viewingModalWidth={viewingModalWidth}
              apiConfig={{
                url: apiConfig.post,
                method: "POST",
                additionalData: { employee_id: id },
              }}
              submitDisabled={!hasActivePosition}
              previousSubmissions={mappedData}
              submitTransform={submitTransform}
              onSubmitted={() => {
                setIsModalOpen(false);
                handleRefresh();
              }}
            />
          </Popup>
        </>
      )}
    </>
  );
};

export default BaseDocumentRequest;
